import StoreUtil from './StoreUtil';

export default {
    error: ( error ) => {
        // eslint-disable-next-line no-unused-expressions
        console?.error?.( StoreUtil.error.getMessage( error ) );
    },
};
